import { FroalaEditorOptions } from './froala-editor-options';
import FroalaEditor from 'froala-editor';

export class FroalaSettings {
    static standardColors = [
        '#000000',
        '#00A885',
        '#1ABC9C',
        '#28324E',
        '#2969B0',
        '#2C82C9',
        '#3D8EB9',
        '#41A85F',
        '#475577',
        '#54ACD2',
        '#553982',
        '#61BD6D',
        '#7C706B',
        '#9365B8',
        '#A38F84',
        '#B8312F',
        '#CCCCCC',
        '#D14841',
        '#D1D5D8',
        '#E25041',
        '#EB6B56',
        '#EFEFEF',
        '#F37934',
        '#F7DA64',
        '#FAC51C',
        '#FBA026',
        '#FFFFFF',
        'REMOVE',
    ];
    static generalOptions: {
        base?: FroalaEditorOptions;
        content?: FroalaEditorOptions;
        image?: FroalaEditorOptions;
        table?: FroalaEditorOptions;
    } = {
        base: {
            attribution: false,
            dragInline: false,
            enter: FroalaEditor.ENTER_BR,
            height: 400,
            key: '2J1B10dB4D4F6D4G3E3cWHNGGDTCWHId1Eb1Oc1Yh1b2Ld1POkE3D3F3A6A4A4C4G3H3F2==',
            lineBreakerOffset: 5,
            lineBreakerTags: ['div'],
            toolbarSticky: false,
        },
        content: {
            codeBeautifierOptions: {
                brace_style: 'expand',
                end_with_newline: true,
                extra_liners:
                    "['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote', 'pre', 'ul', 'ol', 'table', 'dl']",
                indent_char: ' ',
                indent_inner_html: true,
                indent_size: 4,
                wrap_line_length: 0,
            },
            colorsText: FroalaSettings.standardColors,
            colorsBackground: FroalaSettings.standardColors,
            linkEditButtons: ['linkOpen', 'linkEdit', 'linkRemove'],
            paragraphFormat: {
                N: 'Normal',
                H1: 'Heading 1',
                H2: 'Heading 2',
                H3: 'Heading 3',
            },
        },
        image: {
            htmlAllowedAttrs: [...FroalaEditor.DEFAULTS['htmlAllowedAttrs'], 'crossorigin'],
            imageEditButtons: [
                'imageAlign',
                'imageRemove',
                'imageLink',
                'linkOpen',
                'linkEdit',
                'imageAlt',
                'imageSize',
            ],
            imageInsertButtons: ['imageBack', '|', 'imageUpload', 'imageByURL'],
            imageUploadRemoteUrls: false,
            imageUpload: true,
            imageUploadURL: 'custom',
        },
        table: {
            tableEditButtons: [
                // The uncommented list below is the default Froala button table-edit-button lis
                'tableHeader',
                'tableRemove',
                // '|', // this vertical seperator is also a default item in the list
                'tableRows',
                'tableColumns',
                // 'tableStyle',  // turned off because this only styles the table while it is displayed in Froala editor
                '-',
                'tableCells',
                'tableCellBackground',
                'tableCellVerticalAlign',
                'tableCellHorizontalAlign',
                // 'tableCellStyle'   // turned off because this only styles the table while it is displayed in Froala editor
            ],
        },
    };

    static plugins = {
        base: ['draggable'],
        image: ['image'],
        table: ['table'],
        content: [
            'align',
            'codeBeautifier',
            'codeMirror',
            'codeView',
            'colors',
            'entities',
            'fontFamily',
            'fontSize',
            'fullscreen',
            'help',
            'link',
            'lists',
            'paragraphFormat',
            'print',
            'quote',
            'save',
            'url',
            'wordPaste',
        ],
    };

    static toolbarButtons = {
        content: [
            'undo',
            'redo',
            'clearFormatting',
            'bold',
            'italic',
            'underline',
            'color',
            'textColor',
            'backgroundColor',
            'fontFamily',
            'fontSize',
            'paragraphFormat',
            'align',
            'formatOL',
            'formatUL',
            'outdent',
            'indent',
            'quote',
            'insertLink',
            'insertHR',
            'html',
            // 'getPDF',  disabling this since the PDF export functionality is broken
            'fullscreen',
            'help',
        ],
        table: ['insertTable'],
        image: ['insertImage'],
    };
}
